import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { ADMIN_NAMES } from '../../config/teamConfig';
import './ReportsPage.css';

const ProjectReportsPage: React.FC = () => {
  const { user } = useAuth();
  const isAdmin = user?.username
    ? ADMIN_NAMES.some((name) => name.toLowerCase() === user.username.toLowerCase())
    : false;

  if (!isAdmin) {
    return (
      <div className="reports-page">
        <div className="reports-empty">
          <h1>Project Reports</h1>
          <p>You do not have access to this page.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="reports-page">
      <header className="reports-header">
        <div className="reports-title-section">
          <span className="reports-eyebrow">Manager tools</span>
          <h1>Project Reports</h1>
          <p>Project-level performance and utilization reporting.</p>
        </div>
      </header>

      <section className="reports-section">
        <div className="reports-section-header">
          <h2>Coming soon</h2>
        </div>
        <p className="reports-placeholder-copy">
          This view will surface project hours, contributors, and status summaries
          for managers — alongside the Employee Stats report.
        </p>
      </section>
    </div>
  );
};

export default ProjectReportsPage;
